import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import prosoectus from '../assests/img/prosoectus.pdf';
import syllabus from '../assests/img/Syl.pdf';
import regulations from '../assests/img/regulations.pdf';
import { Helmet } from 'react-helmet-async';


function Studentverification() {
  return (
    <div >
      <Helmet>
        <title>Student Verification | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about Student Verification | State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Student Verification</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container skill-education-container'>
          <div className="content-secion">
           <div className="col-md-12 text-left">
						<h2>APPLY FOR VERIFICATION</h2>
<p>Any one can apply for verification of original / photo copy of documents like Detail Marks Certificate / Certificate etc. issued by the board. Individual / companies / organisations / agencies / Govt. departments / Embassies who would like to verify the authenticity of the academic documents may have to following this procedure:</p>
<p>1. Write an application for verification on simple paper or Letter pad and also mention roll no, class , session in application  (also attach self attested photo copies of your documents with application.)</p>
<p>2. ( Send a Demand Draft of Rs. 100/- for postal chargein India and Rs. 1000/- for out side of India in favour of State Board of Secondary Education.)</p>
<p>3. Verification charges for Central / State Govt. departments and Embassies are same.</p>
<p>4. Normal period required for verification 15-30 days.</p>
<p>5. Please, mention your postal adress and Phone No. on the application.</p>
<p>NOTE: VERIFICATION BY EMAIL WILL BE ENTERTAINED AND TELEPHONE / FAX WILL NOT BE ENTERTAINED.</p>
<p>Send all documents by Regd. Post / Speed Post on admin. office address.</p>
<p>S-509, Room No. B-28(2nd floor), Shakarpur School Block-I, NEW DELHI-110092</p>
											
 
</div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Studentverification;
